import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { FiUserRequestsListComponent } from './fi-user-requests-list.component';
import { FiUserRequestsListState } from './user-requests-states';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatButtonModule } from '@angular/material/button';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatCardModule } from '@angular/material/card';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        UIRouterModule.forChild(FiUserRequestsListState),
        ItemsListModule,
        FiWrapperTableModule,
        MatButtonModule,
        FiProfileIconModule,
        MatCardModule,
        FiItemsListModule,
    ],
    declarations: [FiUserRequestsListComponent],
    exports: [FiUserRequestsListComponent],
})
export class UserRequestsAccessModule {}
